function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M81.5885 42.8826V53.6158C81.5885 64.0481 73.0845 72.5745 62.6796 72.5745C52.2747 72.5745 43.7706 64.0481 43.7706 53.6158V0H19.3591V19.1091H0V43.5848H19.3591V53.5657C19.3591 77.4897 38.7683 97 62.6796 97C86.5408 97 106 77.5398 106 53.5657V42.8826H81.5885Z",
  fill: "#3DBEAA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6794 43.5347C69.4205 43.5347 74.8852 38.0556 74.8852 31.2968C74.8852 24.538 69.4205 19.059 62.6794 19.059C55.9383 19.059 50.4736 24.538 50.4736 31.2968C50.4736 38.0556 55.9383 43.5347 62.6794 43.5347Z",
  fill: "#FAC320"
});

function SvgTimetrapLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 97,
    viewBox: "0 0 106 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetrapLogo);
export default __webpack_public_path__ + "static/media/timetrap-logo.fe03361f.svg";
export { ForwardRef as ReactComponent };